// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__U2hYo","legacyBtn":"MutateMid_legacyBtn__2SB3r"};